import styled from 'styled-components'
import { Button } from '@components/Button'
import { Pill } from '@components/Pill'

export const HeroActions = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`

export const TripSettingsButton = styled(Button).attrs({ variant: 'secondary' as const })``

export const ChatButton = styled(Button).attrs({ variant: 'secondary' as const })``

/** My unread Messages, capped at 9+. */
export const UnreadBadge = styled(Pill).attrs({ $tone: 'accent', $size: 'sm' })``
